/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  SET_ACTIVE: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.userList.setActive',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'SET_ACTIVE' },
      },
    },
    SET_ACTIVE: {
      invoke: {
        id: 'setActive',
        src: 'setActive',
        onDone: {
          target: 'SET_ACTIVE_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'SET_ACTIVE_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    SET_ACTIVE_SUCCESS: {
      on: {
        START: { target: 'SET_ACTIVE' },
      },
    },
    SET_ACTIVE_FAILED: {
      on: {
        START: { target: 'SET_ACTIVE' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
